export default {
  'api.label.authorization.inheritLabel': 'View authorization {type} of this Api',
  'api.label.authorization.inheritLabel.folder': 'Inherited from group [{folderName}]',
  'api.label.authorization.inheritLabel.project': 'Inherited from project',

  'api.label.authorization.description.apikey':
    'Add parameter in {position} <div class="locals-tag">{key}</div>',
  'api.label.authorization.description.bearer':
    'Provide your bearer token in the <div class="locals-tag">Authorization</div> header when making requests to protected resources.',
  'api.label.authorization.description.basic':
    'Send your HTTP requests with an <div class="locals-tag">Authorization</div> header that contains the word Basic followed by a space and a base64-encoded string <span class="ui-tag whitespace-normal break-all"><code>username:password</code></span>',
  'api.label.authorization.description.digest':
    'Provide your encrypted digest scheme data in the <div class="locals-tag">Authorization</div> header when making requests to protected resources.',
  'api.label.authorization.description.hawk':
    'Provide your encrypted Hawk scheme data in the <div class="locals-tag">Authorization</div> header when making requests to protected resources.',
  'api.label.authorization.description.aws':
    'Add parameters <div class="locals-tag">Authorization</div> and <div class="locals-tag">X-Amz-Date</div> to Header',
  'api.label.authorization.description.aws.url':
    'Add parameters <div class="locals-tag">Authorization</div> info and <div class="locals-tag">X-Amz-Date</div> on URL',
  'api.label.authorization.description.edgegrid':
    'Add the parameter <div class="locals-tag">Authorization</div> to Header, whose value is to concatenate the digest encryption scheme after EG1-HMAC-SHA256',

  'api.label.authorization': 'Authorization',
  'api.label.parameters': 'Request',
  'api.label.codeSample': 'Request Code Samples',
  'api.label.responses': 'Responses',
  'api.label.example': 'Example',
  'api.label.callbacks': 'Callbacks',
  'api.label.dataSchema': 'Schemas',
  'api.auth.label.addAuthDataTo': 'Add to',
  'api.auth.label.addTo': 'Add to',
  'api.auth.label.more': 'Advanced',
  'api.auth.label.moreTip':
    'These are advanced configuration options. They are optional. {appName} will auto generate values for some fields if left blank.',
  'api.auth.label.disableRetryRequest': 'Disable retrying the request',
  'api.auth.label.disableRetryRequestTip':
    'By default, {appName} will extract values from the received response, add it to the request, and retry it. Do you want to disable this?',
  'api.parameterLabel.name': 'Name',
  'message.bodyParameter': 'Body Params  ',
  'api.parameterLabel.value': 'Value',
  'api.parameterLabel.example': 'Example',
  'api.parameterLabel.type': 'Type',
  'api.parameterLabel.noNeedToDefineTheBody': 'No need to define the Body',
  'api.parameterLabel.noNeedToDefineTheResponse': 'No need to define the Response',
  'message.hasNoResponseBody': 'This response does not have a body.',
  'api.parameterLabel.file.disabled.tip':
    'The file type is not supported when the Body is x-www-form-urlencode, please use form-data instead',
  'api.status.designing': 'Designing',
  'api.status.pending': 'Pending',
  'api.status.developing': 'Developing',
  'api.status.integrating': 'Integrating',
  'api.status.testing': 'Testing',
  'api.status.tested': 'Tested',
  'api.status.released': 'Released',
  'api.status.deprecated': 'Deprecated',
  'api.status.exception': 'Exception',
  'api.status.obsolete': 'Obsolete',
  'api.automaticGenerated': ' Auto-generate',
  'response.label.headers': 'Headers',
  'response.label.body': 'Body',
  'response.label.contentType': 'Content Type ',
  'quickDebug.placeHolder.error': 'URL Format Incorrect , {detail}',
  'quickDebug.placeHolder.detail': 'Type in the full URL starting with http or https',
  'message.queryParameter': 'Query Params',
  'message.pathParameter': 'Path Params',
  'message.headerParameter': 'Header Params',
  'message.cookieParameter': 'Cookie Params',
  'message.hasNoBodyParameter': "This request has no 'body' construction",
  'api.auth.beginnerTips':
    'Authorization added here will be applied to all requests under this group and can be modified within specific requests',
  'api.auth.label.type': 'Type',
  'parameter.count.none': 'None',
  'api.requestBody.binary.uploaded': 'Uploaded File',
  'api.requestBody.binary.notConfigured': 'Not configured',
  'api.request.auth.jwt.algorithm.label': 'Algorithm',
  'api.request.auth.jwt.secret.label': 'Secret',
  'api.request.auth.jwt.isSecretBase64Encoded.label': 'Secret is Base64 Encoded',
  'api.request.auth.jwt.payload.label': 'Payload',
  'api.request.auth.jwt.headerPrefix.label': 'HTTP Authorization Prefix',
  'api.request.auth.jwt.header.label': 'Custom JWT Header',
  'api.request.auth.jwt.privateKey.label': 'Private Key',
  'api.request.auth.jwt.privateKey.button.label': 'Choose File',
  'api.request.auth.jwt.queryParamKey.label': 'Query Param Name',
  'api.request.auth.jwt.algorithm.placeholder': 'Please select an algorithm',
  'api.request.auth.jwt.secret.placeholder': 'Secret',
  'api.request.auth.jwt.payload.placeholder': 'Compose with JSON',
  'api.request.auth.jwt.headerPrefix.placeholder': 'HTTP Authorization Prefix',
  'api.request.auth.jwt.header.placeholder': 'Compose with JSON',
  'api.request.auth.jwt.privateKey.placeholder':
    '-----BEGIN PRIVATE KEY-----\nPrivate key in PKCS#8 PEM format\n-----END PRIVATE KEY-----',
  'api.request.auth.jwt.queryParamKey.placeholder': 'Query Param Name',
  'api.label.authorization.jwt.description1':
    'Add the parameter <div class="locals-tag">{name}</div> to {addTokenTo}',
  'api.label.authorization.jwt.description2':
    '，whose value is to concatenate the Token after the {headerPrefix}.',

  'api.label.authorization.oauth2.httpAuthorizationPrefix.label': 'HTTP Authorization Prefix',
  'api.label.authorization.oauth2.grantType.label': 'Grant Type',
  'api.parameterLabel.contentType': 'Content-Type',
  'modified.at.label': 'Modified at',
  'built.with': 'Built with',
  slogan: 'All-in-One API Platform: Design, Debug, Mock, Test, and Document',
  'doc.anchor.title': 'On this page',
  'http.status.code.tooltip': 'HTTP Status Code',
  examples: 'Examples',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.title': 'Use Parent Default Auth Values',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.desc':
    'Use the default auth values configured in the parent folder.',
  'api.auth.securitySchemeUseCase.valueAssignment.override.title': 'Set Manually',
  'api.auth.securitySchemeUseCase.valueAssignment.override.desc':
    'Manually configure the required values for authorization.',
  'api.auth.folderSecuritySchemeUseCase.defaultValue': 'Default Auth Values',
  'api.auth.securitySchemeDefinition.more':
    '{count, plural, one {And {count, number} other.} other {And {count, number} others.}}',
  'api.auth.securitySchemeDefinition.notToAuth': 'Not to Auth',
  'api.auth.securitySchemeUseCase.valueIn': 'In {in}',
  'api.label.sourceUrl': ' Original link',
  'api.label.operationId': 'OperationId',
  'api.customAuth.error.message.title': 'Error',
  'api.customAuth.redirect.title': 'Redirecting...',
  'api.action.mcp.modal.description':
    'Allow AI tools to access full API docs site for AI-assisted coding.',
  'api.action.mcp.modal.editor.other': 'Others',
  'api.action.mcp.modal.cursor.copy': 'One-click setup',
  'api.action.mcp.modal.cursor.or': 'or',
  'api.action.mcp.modal.cursor.manualCopy': 'Manual configuration',
  'api.action.mcp.modal.cursor.button.text': 'Click here to add to Cursor',
  'api.action.mcp.modal.cursor.version': 'Only supports Cursor version 1.0 and above',
  'api.action.mcp.modal.commandTip': 'Note: Node.js environment must be installed (version >= 18)',
  'api.action.mcp.modal.footer.question': 'How to use MCP after copying the JSON?',
  'api.action.mcp.modal.footer.help': 'View help documentation',
  'api.action.mcp.modal.command.doc': 'API Documentation',
};
